/**
 * Created by Jonas Wålekvist on 2018-05-31.
 */

import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {
    ISymbolSizeConfig,
    ISymbolStateConfig, ISymbolStates,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite, Elastic} from "gsap";
import {DragonTribeGameConfig} from "../DragonTribeGameConfig";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";

export interface IDragonTribeSymbolStates extends ISymbolStates {
    noWin:ISymbolStateConfig;
    attention:ISymbolStateConfig;
    expand:ISymbolStateConfig;
    plus:ISymbolStateConfig;
    crack:ISymbolStateConfig;
}

export class DTReelSymbol extends StateReelSymbol {
    protected _symMask:PIXI.Graphics | null;
    protected _symBackground:PIXI.Sprite;
    protected _symTop:PIXI.Sprite;
    protected _symBottom:PIXI.Sprite;
    protected _symSides:PIXI.Sprite;
    protected _crack0:PIXI.Sprite;
    protected _crack1:PIXI.Sprite;
    protected _highlight:PIXI.Sprite;

    public createEmptySprite(texture:string, anchorY:number = 0.5):PIXI.Sprite {
        const temp:PIXI.Sprite = new PIXI.Sprite();
        temp.anchor.set(0.5, anchorY);
        temp.position.set(0, 0);
        if(texture.length > 0) {
            temp.texture = GameResources.getTextures(texture)[0];
        }
        this.addChild(temp);
        return temp;
    }

    protected initAnimations():void {
        if(!this._symBackground) {
            this._symBackground = this.createEmptySprite("");
            this._symBackground.name="symBackground";
        }

        if(!this._crack0) {
            this._crack0 = new PIXI.Sprite(GameResources.getTextures("rockCrack0")[0]);
            this._crack0.name="rockCrack0";
            this._crack0.anchor.set(0.5, 0.5);
            this._crack0.position.set(0, 0);
            this._crack0.alpha = 0;
        }

        if(!this._crack1) {
            this._crack1 = new PIXI.Sprite(GameResources.getTextures("rockCrack1")[0]);
            this._crack1.name="rockCrack1";
            this._crack1.anchor.set(0.5, 0.5);
            this._crack1.position.set(0, 0);
            this._crack1.alpha = 0;
        }

        if(!this._highlight) {
            this._highlight = new PIXI.Sprite(GameResources.getTextures("potentialGlow")[0]);
            this._highlight.name="highlight";
            this._highlight.anchor.set(0.5, 0.5);
            this._highlight.position.set(0, 0);
            this._highlight.alpha = 0;
            this._highlight.blendMode = PIXI.BLEND_MODES.ADD;
        }

        this.createFrame();
    }

    protected createFrame():void {
        if(!this._symSides) {
            this._symSides = this.createEmptySprite("");
            this._symSides.name="symSide";
        }

        if(!this._symBottom) {
            this._symBottom = this.createEmptySprite("", 1);
            this._symBottom.name="symBottom";
        }

        if(!this._symTop) {
            this._symTop = this.createEmptySprite("", 0);
            this._symTop.name="symTop";
        }

    }

    public set symHeight(value:number) {
        if(value === this.symHeight) {
            return;
        }
        this._symHeight = value;
        if(this.symName.indexOf("W0") > -1) {
            this.resetSymMask();
            this.resetBackGround();
            return;
        }
        this.updateHeightDisplay();
        this.updateBackground(value);
        this.resetSymMask();
        this.drawSymMask();
    }

    public get symHeight():number {
        if(this._symHeight == null) {
            return GameConfig.instance.SYMBOL_HEIGHT;
        }

        return this._symHeight;
    }

    public playHighlightAnimation():void {
        const tl:TimelineLite = new TimelineLite().add([
            () => {
                this.addChild(this._highlight);
            },
            TweenLite.fromTo(this._highlight, 0.4, {alpha : 0}, {alpha : 1}),
            TweenLite.fromTo(this._highlight, 0.1, {alpha : 1}, {alpha : 0, delay : 0.5})
        ]);
    }

    protected updateHeightDisplay():void {
        // = MathHelper.roundToDecimals(this._symHeight / GameConfig.instance.SYMBOL_HEIGHT, 2);
    }

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig) {
        super(symName, reelId, state, size);
        if(this.symName.indexOf("X") > -1) {
            this.visible = false;
            return;
        }
    }

    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);
        if(newState.state.keyword === DragonTribeGameConfig.instance.SYMBOL_STATES.crack.keyword) {
            const crackTimeline:TimelineLite = new TimelineLite().add([
                () => {
                    this.addChild(this._crack0);
                    this.addChild(this._crack1);
                },
                TweenLite.fromTo(this._crack0, 0.1, {alpha : 0}, {alpha : 1, ease : Elastic.easeIn}),
                TweenLite.fromTo(this._crack1, 0.1, {alpha : 0}, {alpha : 1, delay : 0.1})
            ]);
            timeline.add(crackTimeline, delay);
            timeline.add(() => {
                this.visible = false;
            }, delay + crackTimeline.duration());
        }

        if(newState.state.keyword === DragonTribeGameConfig.instance.SYMBOL_STATES.win.keyword) {
            if(this.symName === ReelSymbolName.SCATTER) {
                return;
            }
            const scale:number = (this.symName.indexOf("W")>-1)?1:0.7;

            timeline.add([
                TweenLite.to(this, 0.3, {alpha : 0.3}),
                TweenLite.to(this.scale, 0.3, {x : scale, y : scale})
            ], delay);

            timeline.add([
                TweenLite.to(this, 0.2,  {alpha : 0})
            ], delay+0.3);
        }
    }

    protected reset(remove:boolean):void {
        if(this._symBackground) {
            this.removeChild(this._symBackground);
        }

        if(this._crack0) {
            this.removeChild(this._crack0);
        }

        if(this._crack1) {
            this.removeChild(this._crack1);
        }

        if(this._highlight) {
            this.removeChild(this._highlight);
        }

        if(this._symSides) {
            this.removeChild(this._symSides);
        }

        if(this._symBottom) {
            this.removeChild(this._symBottom);
        }

        if(this._symTop) {
            this.removeChild(this._symTop);
        }

        this._currentState = null;
        this._currentStateAnimation = null;

        // TODO: shall we reuse something for the performance?
        if(this._stateAnimations) {
            for(let key in this._stateAnimations) {
                if(this._stateAnimations[key]) {
                    this.removeChild(this._stateAnimations[key]!);
                    this._stateAnimations[key]!.destroy({children : true});
                }
            }
        }
        this._stateAnimations = {};
        this.resetSymMask()
    }

    protected resetSymMask():void {
        if(this._symMask) {
            // TODO: #276
            // this.mask = null;
            this.removeChild(this._symMask!);
            this._symMask = null;
        }
    }

    protected drawSymMask():boolean {
        if(this.symHeight < 255) {
            this._symMask = new PIXI.Graphics();
            this._symMask.beginFill(0xFF0000, 1);
            this._symMask.drawRect(-GameConfig.instance.SYMBOL_WIDTH / 2, -this.symHeight / 2, GameConfig.instance.SYMBOL_WIDTH + 20, this.symHeight);
            this.addChild(this._symMask);
            this.mask = this._symMask;
            return true;
        }
        return false;
    }

    public updateBackground(symHeight:number,callFromAs:boolean=false):void {
        if(callFromAs){
            const mainSprite=this.removeChildAt(0);
            if(this._symBackground && this.addChildrenForAS(this._symBackground.name)){
                this.addChild(this._symBackground);
            }
            if(this._crack0 && this.addChildrenForAS(this._crack0.name)){
                this.addChild(this._crack0);
            }
            if(this._crack1 && this.addChildrenForAS(this._crack1.name)){
                this.addChild(this._crack1);
            }
            if(this._highlight && this.addChildrenForAS(this._highlight.name)){
                this.addChild(this._highlight);
            }
            if(this._symSides && this.addChildrenForAS(this._symSides.name)){
                this.addChild(this._symSides);
            }
            if(this._symBottom && this.addChildrenForAS(this._symBottom.name)){
                this.addChild(this._symBottom);
            }
            if(this._symTop && this.addChildrenForAS(this._symTop.name)){
                this.addChild(this._symTop);
            }
            this.drawSymMask();
            this.addChild(mainSprite);
        }
        this._symBackground.visible = true;
        this.updateFrame();
    }
    private addChildrenForAS(childName:string):boolean{
        for(let i:number=0;i<this.children.length;i++){
            if(this.children[i].name==childName){
                return false;
            }
        }
        return true
    }

    protected updateFrame():void {
        const isLSym:boolean = (this.symName.indexOf("L") > -1);
        this._symTop.visible = !isLSym;
        this._symSides.visible = !isLSym;
        this._symBottom.visible = !isLSym;
        this._symTop.y = -this.symHeight / 2 - 14;
        this._symBottom.y = this.symHeight / 2 + 15;
    }

    public resetBackGround() {
        this._symTop.visible = false;
        this._symSides.visible = false;
        this._symBottom.visible = false;
        this._symBackground.visible = false;
    }
}